import { LOGIN, FORGOT_PASSWORD, CHANGE_PASSWORD, TWO_FACTOR } from '../actions';

export const ERROR_TEXTS = {
  [LOGIN.FAILED]: 'invalid user credentials',
  [FORGOT_PASSWORD.FAILED]: 'invalid email',
  [CHANGE_PASSWORD.FAILED]: 'wrong password',
  [TWO_FACTOR.FAILED]: 'invalid verification code'
};

export const ARE_YOU_SURE_TEXT = 'You have unsaved changes, are you sure you want to leave?';
